import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import P1DoctorSetup from './P1DoctorSetup';

interface Props extends BaseModalProps {
	onSave: () => void;
}

const P1DoctorSetupModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.p1DoctorSetup.modalTitle'>
			<P1DoctorSetup onSave={props.onSave} />
		</BaseModal>
	);
};

export default P1DoctorSetupModal;
